import type { RouteParams } from 'types';
import { addDatesToFiltersSearch } from 'utils/parserTree';
import type { Tree } from 'utils/parserTree';

function buildExploreParamsForInvestigationBySearch(
  resourceParams: RouteParams,
  tree?: Tree | null
): Record<string, string | string[]> {
  const strippedParams = { ...resourceParams } as Record<string, unknown>;
  delete strippedParams.investigation_uuid;

  if ('states' in strippedParams && strippedParams.states != null) {
    strippedParams.event_states = strippedParams.states;
    delete strippedParams.states;
  }

  let paramsObj: Record<string, unknown> = {
    ...strippedParams,
    offset: 0,
    limit: -1,
  };

  if ('filters_search' in strippedParams && strippedParams.filters_search) {
    paramsObj = {
      include_count: true,
      filters_search: strippedParams.filters_search,
      order_by: strippedParams.order_by,
      order_desc: strippedParams.order_desc,
    };
    if (
      (strippedParams.created_after || strippedParams.created_before) &&
      !strippedParams.days_from_oor &&
      tree
    ) {
      const fs = addDatesToFiltersSearch(strippedParams as RouteParams, tree);
      if (fs) {
        paramsObj.filters_search = fs;
      }
    }
    if (strippedParams.sample_uuid) {
      paramsObj.sample_uuid = strippedParams.sample_uuid;
    }
  }

  if (strippedParams.has_events && Array.isArray(strippedParams.has_events)) {
    paramsObj.has_events = strippedParams.has_events;
  }

  const out: Record<string, string | string[]> = {};
  Object.entries(paramsObj).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    if (Array.isArray(v)) {
      out[k] = v.map((x) => String(x));
    } else {
      out[k] = String(v);
    }
  });

  out.offset = '0';
  out.limit = '-1';

  return out;
}

export default buildExploreParamsForInvestigationBySearch;
